import adesao from '@/core/store/ata/pesquisa/adesao'

export default {
	modules: {
		adesao,
	},
}
